import { createContext, useContext, useMemo } from 'react';

import { Editor } from '@tiptap/core';

type EditorContextType = {
  editor: Editor | null;
};

const EditorContext = createContext<EditorContextType>({
  editor: null,
});

export const useCurrentEditor = () => {
  const context = useContext(EditorContext);
  if (context === undefined || context.editor === null) {
    throw new Error('useCurrentEditor must be used within a EditorProvider');
  }

  return context;
};

// Hook that returns the current editor from context without throwing.
// Use this when you need to support both EditorProvider and non-provider contexts
export const useCurrentEditorOrNull = () => {
  return useContext(EditorContext);
};

export const EditorProvider = ({
  editor,
  children,
}: {
  editor: Editor;
  children: React.ReactNode;
}) => {
  const value = useMemo(() => ({ editor }), [editor]);

  return (
    <EditorContext.Provider value={value}>{children}</EditorContext.Provider>
  );
};
